import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "mode-selection" }
const _hoisted_2 = { class: "a-ticketModeOption__content" }
const _hoisted_3 = { class: "a-ticketModeOption__indicator -is-modal-link" }
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = {
  key: 2,
  class: "a-ticketModeOption vertical-filler"
}
const _hoisted_7 = {
  key: 1,
  class: "a-ticketModeSelection"
}
const _hoisted_8 = { class: "a-ticketModeOption__content" }
const _hoisted_9 = ["data-qa"]
const _hoisted_10 = { class: "a-ticketModeOption__content" }
const _hoisted_11 = ["data-qa"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.displayModeState.bestSeat)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activateSeatmap())),
                class: "a-ticketModeOption",
                tabindex: "0",
                onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleKeyPress($event, _ctx.Selection.SEATMAP)))
              }, [
                _createVNode(_component_icon_component, {
                  class: "a-ticketModeOption__icon",
                  "icon-id": _ctx.IconName.BestSeat
                }, null, 8, ["icon-id"]),
                _createElementVNode("div", _hoisted_2, [
                  _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                    _createTextVNode("Seatmap selection")
                  ])), [
                    [_directive_translate, { key: _ctx.Translation.Seatmap_trigger }]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("p", null, [
                    _createTextVNode("Choose your own seats")
                  ])), [
                    [_directive_translate, { key: _ctx.Translation.Seatmap_trigger_detail }]
                  ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "a-ticketModeOption__indicatorCircle",
                    "data-qa": _ctx.PerformanceQASelectors.PRICE_LEVEL_CIRCLE_INDICATOR
                  }, [
                    _createVNode(_component_icon_component, {
                      "icon-id": _ctx.IconName.ArrowFull
                    }, null, 8, ["icon-id"])
                  ], 8, _hoisted_4)
                ])
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.isMobileMenuOpen())
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activateBestseat())),
                class: "a-ticketModeOption is-seatmap-active",
                tabindex: "0",
                onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleKeyPress($event, _ctx.Selection.BEST_SEAT)))
              }, [
                _createVNode(_component_icon_component, {
                  class: "a-ticketModeOption__icon",
                  "icon-id": _ctx.IconName.Arrow
                }, null, 8, ["icon-id"]),
                _createElementVNode("div", null, [
                  _withDirectives((_openBlock(), _createElementBlock("p", null, [
                    _createTextVNode("Back to best seat selection")
                  ])), [
                    [_directive_translate, { key: _ctx.Translation.Seatmap_exit_seatmap_selection }]
                  ]),
                  _hoisted_5
                ])
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.isMobileMenuOpen())
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.isMobile && _ctx.displayModeState.seatmap.isSeatmapVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleEventHeaderExpansion())),
                class: "a-ticketModeOption__expand"
              }, [
                _createVNode(_component_IconComponent, {
                  class: _normalizeClass(["a-ticketModeOption__arrowDown", { '-rotatedLeft': _ctx.isMobileMenuOpen(), '-rotatedRight': !_ctx.isMobileMenuOpen() }]),
                  "icon-id": _ctx.IconName.Arrow
                }, null, 8, ["icon-id", "class"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activateBestseat())),
            class: "a-ticketModeOption",
            tabindex: "0",
            onKeydown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleKeyPress($event, _ctx.Selection.BEST_SEAT)))
          }, [
            _createVNode(_component_icon_component, {
              class: "a-ticketModeOption__icon",
              "icon-id": _ctx.bestseatIconName
            }, null, 8, ["icon-id"]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                _createTextVNode("Best seat")
              ])), [
                [_directive_translate, { key: _ctx.Translation.Bestseat_trigger }]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("p", null, [
                _createTextVNode("Choose your price, we choose your seats")
              ])), [
                [_directive_translate, { key: _ctx.Translation.Bestseat_trigger_detail }]
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["a-ticketModeOption__indicator", { '-is-active': _ctx.displayModeState.bestSeat }])
            }, [
              _createElementVNode("div", {
                class: "a-ticketModeOption__indicatorCircle",
                "data-qa": _ctx.PerformanceQASelectors.PRICE_LEVEL_CIRCLE_INDICATOR
              }, null, 8, _hoisted_9)
            ], 2)
          ], 32),
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.activateSeatmap && _ctx.activateSeatmap(...args))),
            class: "a-ticketModeOption",
            tabindex: "0",
            onKeydown: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleKeyPress($event, _ctx.Selection.SEATMAP)))
          }, [
            _createVNode(_component_icon_component, {
              class: "a-ticketModeOption__icon",
              "icon-id": _ctx.seatmapIconName
            }, null, 8, ["icon-id"]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                _createTextVNode("Seatmap selection")
              ])), [
                [_directive_translate, { key: _ctx.Translation.Seatmap_trigger }]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("p", null, [
                _createTextVNode("Choose your own seats")
              ])), [
                [_directive_translate, { key: _ctx.Translation.Seatmap_trigger_detail }]
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["a-ticketModeOption__indicator", { '-is-active': _ctx.displayModeState.seatmap.isSeatmapVisible }])
            }, [
              _createElementVNode("div", {
                class: "a-ticketModeOption__indicatorCircle",
                "data-qa": _ctx.PerformanceQASelectors.PRICE_LEVEL_CIRCLE_INDICATOR
              }, null, 8, _hoisted_11)
            ], 2)
          ], 32)
        ]))
  ]))
}